<form #formCards class="example-form" (keydown.enter)="submit()">
    <div
        style="position: relative"
        *ngFor="let card of cardsAsFormArray; let i = index; let last = last; let first = first"
        [formGroup]="card"
    >
        <div class="auto-wrapper" [ngClass]="{ 'confirm-card': getControl(i, 'checked').value }">
            <mat-form-field class="example-full-width" appearance="fill">
                <mat-label>מספר כרטיס (max או כל כרטיס אחר)</mat-label>
                <input
                    #inputAuto
                    matInput
                    aria-label="State"
                    [matAutocomplete]="auto"
                    (blur)="valueChange($event, i)"
                    formControlName="cardNumber"
                    appNumberWithoutSymbol
                    maxlength="16"
                    type="tel"
                />

                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelect($event, i)">
                    <mat-option *ngFor="let state of filtred" [value]="state">
                        <img class="example-option-img" aria-hidden [src]="state.cardImage" height="22" />
                        <span>xxxx-xxxx-xxxx-</span>
                        <span>{{ state.shortCardNumber }}</span>
                        <span> {{ state.cardName }} </span>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>
        <div class="erase-wrapper" *ngIf="getControl(i, 'cardNumber').value" (click)="resetAutoComplete($event, i)">
            <span class="erase-number"></span>
        </div>

        <div class="msg">
            <div class="err-msg" *ngIf="getControl(i, 'cardNumber').touched && getControl(i, 'cardNumber').errors">
                <span *ngIf="getControl(i, 'cardNumber').errors.required">‏חובה להזין מספר כרטיס</span>
                <span *ngIf="getControl(i, 'cardNumber').errors.length"
                    >יש להקליד מספר כרטיס מלא בן 8 ל 16 ספרות ללא תווים מיוחדים</span
                >
            </div>
            <div class="err-msg">
                <span>{{ getControl(i, 'error').value }}</span>
            </div>
            <div class="multiple-card" *ngIf="ISHokMultipleCard">
                <a class="link delete-card" title="" (click)="removeCardForm(i)" *ngIf="!first"> ‏הסרט כרטיס </a>
                <a class="link add-card" title="" (click)="addCardForm()" *ngIf="last"> + הוסף כרטיס נוסף </a>
            </div>
        </div>
    </div>
    <div class="button-wrapper">
        <a ComadminDisabled (click)="submit()" class="brand-button green-button" title=""><span>בואו נתחיל!</span></a>
        <a *ngIf="displayBenefit" (click)="openCalc()" class="link open-calc" title="">תראו לי מה יצא לי מזה?</a>
    </div>
</form>
